// I probably would have just put this in FrontRoyalStore, but doing so led to circular dependencies
export default class NotEnoughStorageError extends Error {
    constructor() {
        super('Not enough storage space available');
        this.name = 'NotEnoughStorageError';
    }
}
